export default {"src":"/nachrichten/_next/static/media/favicon.6a639221.svg","height":306,"width":306,"blurWidth":0,"blurHeight":0};